export const routeMap = {
  'wirkaufendeinauto.at': 'router.wirkaufendeinauto.at',
  'wijkopenautos.be': 'router.wijkopenautos.be',
  'wirkaufendeinauto.de': 'router.wirkaufendeinauto.de',
  'vikoberallebiler.dk': 'router.vikoberallebiler.dk',
  'compramostucoche.es': 'router.compramostucoche.es',
  'vendezvotrevoiture.be': 'router.vendezvotrevoiture.be',
  'vendezvotrevoiture.fr': 'router.vendezvotrevoiture.fr',
  'noicompriamoauto.it': 'router.noicompriamoauto.it',
  'wijkopenautos.nl': 'router.wijkopenautos.nl',
  'kupimytwojsamochod.pl': 'router.kupimytwojsamochod.pl',
  'compramososeucarro.pt': 'router.compramososeucarro.pt',
  'vikoperdinbil.se': 'router.vikoperdinbil.se',
  'wkfda.at': 'router.wkfda.at',
  'wikoau.be': 'router.wikoau.be',
  'wkda.de': 'router.wkda.de',
  'vkab.dk': 'router.vkab.dk',
  'cotuco.es': 'router.cotuco.es',
  'vevovo.be': 'router.vevovo.be',
  'vevovo.fr': 'router.vevovo.fr',
  'nocoau.it': 'router.nocoau.it',
  'wikoau.nl': 'router.wikoau.nl',
  'cosc.pt': 'router.cosc.pt',
  'vkdb.se': 'router.vkdb.se',
  'frontend-qa-1.auto1-test.com': 'router-qa-1.cfe.auto1-test.com',
  'auto1-test.com': 'router-qa-1.cfe.auto1-test.com',
  'localhost': 'router-qa-1.cfe.auto1-test.com'
};
//# sourceMappingURL=route-map.js.map